import { render } from "./PatientRetention.vue?vue&type=template&id=5b711d7e&scoped=true"
import script from "./PatientRetention.js?vue&type=script&lang=js"
export * from "./PatientRetention.js?vue&type=script&lang=js"

import "./PatientRetention.vue?vue&type=style&index=0&id=5b711d7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b711d7e"]])

export default __exports__